import type { IEntity, IPoint } from "dxf-parser";
import type { IGroup } from "dxf-parser/dist/DxfArrayScanner";
import type DxfArrayScanner from "dxf-parser/dist/DxfArrayScanner";
import type IGeometry from "dxf-parser/dist/entities/geomtry";
import * as helpers from "lib/house/dxf/import/dxfParserLibHelpers";

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface ISolidEntity extends IEntity {
  firstCorner?: IPoint;
  secondCorner?: IPoint;
  thirdCorner?: IPoint;
  fourthCorner?: IPoint;
}

export default class Solid implements IGeometry {
  public ForEntityName = "SOLID" as any;

  public parseEntity(scanner: DxfArrayScanner, curr: IGroup) {
    const entity = {
      type: curr.value,
    } as ISolidEntity;

    curr = scanner.next();
    while (!scanner.isEOF()) {
      if (curr.code === 0) {
        break;
      }

      switch (curr.code) {
        case 10: // X coordinate of first corner
        case 20: // Y coordinate of first corner
        case 30: // Z coordinate of first corner
          entity.firstCorner = helpers.parsePoint(scanner);
          break;
        case 11: // X coordinate of second corner
        case 21: // Y coordinate of second corner
        case 31: // Z coordinate of second corner
          entity.secondCorner = helpers.parsePoint(scanner);
          break;
        case 12: // X coordinate of third corner
        case 22: // Y coordinate of third corner
        case 32: // Z coordinate of third corner
          entity.thirdCorner = helpers.parsePoint(scanner);
          break;
        case 13: // X coordinate of fourth corner
        case 23: // Y coordinate of fourth corner
        case 33: // Z coordinate of fourth corner
          entity.fourthCorner = helpers.parsePoint(scanner);
          break;
        default:
          helpers.checkCommonEntityProperties(entity, curr, scanner);
          break;
      }

      curr = scanner.next();
    }

    return entity;
  }
}
